"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
import React, { forwardRef } from "react";
import { TransitionGroup, Transition } from "react-transition-group";
import Button, { ButtonType } from "../Button/Button";
import Tooltip from "../Tooltip/Tooltip";
import { AnimationDuration } from "../../../styles/Animations";
import forceReflow from "../../../utils/forceReflow";
import * as styles from "./IconButton-css";
var IconButton = forwardRef(function (_a, ref) {
  var _b = _a,
    type = _b.type,
    icon = _b.icon,
    disabled = _b.disabled,
    tooltip = _b.tooltip,
    disabledReason = _b.disabledReason,
    ariaLabel = _b["aria-label"],
    size = _b.size,
    buttonProps = __objRest(_b, ["type", "icon", "disabled", "tooltip", "disabledReason", "aria-label", "size"]);
  var tooltipContent = disabled && !!disabledReason ? disabledReason : tooltip == null ? void 0 : tooltip.content;
  var tooltipBasedLabel = (tooltip == null ? void 0 : tooltip.show) ? void 0 : tooltip == null ? void 0 : tooltip.content.toString();
  var renderButton = function renderButton() {
    var _a2;
    return /* @__PURE__ */React.createElement(Button, __spreadValues({
      isIconOnly: true,
      disabled: disabled,
      type: type,
      ref: ref,
      size: size,
      "aria-label": ariaLabel || tooltipBasedLabel
    }, buttonProps), /* @__PURE__ */React.createElement(TransitionGroup, {
      component: null
    }, /* @__PURE__ */React.createElement(Transition, {
      onEnter: forceReflow,
      key: (_a2 = icon.key) != null ? _a2 : void 0,
      timeout: AnimationDuration.Medium
    }, function (status) {
      return /* @__PURE__ */React.createElement("div", {
        className: styles.iconWrapper({
          status: status
        })
      }, icon);
    })));
  };
  if (tooltip) {
    return /* @__PURE__ */React.createElement(Tooltip, __spreadProps(__spreadValues({
      wrapTarget: disabled
    }, tooltip), {
      content: tooltipContent != null ? tooltipContent : ""
    }), renderButton());
  }
  return renderButton();
});
IconButton.defaultProps = {
  type: ButtonType.Tertiary
};
export default IconButton;